module.exports = __webpack_public_path__ + "static/media/img-mygood-quote@3x.bfae8477.png";